var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 279,
    viewBox: "0 0 142 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M116.412 100.491C116.412 100.491 152.671 200.84 125.584 214.207C98.4973 227.575 9.14618 172.346 9.14618 172.346L0 174.456L18.9959 138.575L79.5014 155.109L81.7093 104.805",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7325 127.058L79.5013 155.109L50.9661 147.311C45.4447 158.41 42.0825 173.108 42.0825 189.231C42.0825 189.758 42.0862 190.284 42.0935 190.808C62.7205 201.467 88.8957 213.257 107.905 215.796C110.102 207.113 111.196 198.187 111.161 189.231C111.161 157.171 97.8699 130.743 80.7325 127.058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M107.809 99.6275L66.6195 96.8059L59.1302 99.8562L55.6104 279.736H93.8674L89.8223 272.487L107.809 99.6275Z",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0249 13.121V19.6225C72.0249 22.0654 72.844 24.4377 74.3512 26.3602C75.8583 28.2827 77.9666 29.6443 80.3389 30.2274L90.6849 32.7703V7.35064L82.0823 5.23625C80.8867 4.9424 79.6399 4.92428 78.4363 5.18327C77.2327 5.44226 76.1037 5.97158 75.1348 6.73118C74.1659 7.49078 73.3824 8.46077 72.8437 9.56778C72.3049 10.6748 72.0249 11.8898 72.0249 13.121V13.121Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0249 19.6226C72.0249 22.0654 72.844 24.4377 74.3512 26.3602C75.8583 28.2827 77.9666 29.6443 80.3389 30.2274L90.6849 32.7703",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5658 18.3326C82.8414 18.3326 83.0648 18.1092 83.0648 17.8336C83.0648 17.5581 82.8414 17.3347 82.5658 17.3347C82.2903 17.3347 82.0669 17.5581 82.0669 17.8336C82.0669 18.1092 82.2903 18.3326 82.5658 18.3326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9022 18.3326C75.1778 18.3326 75.4012 18.1092 75.4012 17.8336C75.4012 17.5581 75.1778 17.3347 74.9022 17.3347C74.6267 17.3347 74.4033 17.5581 74.4033 17.8336C74.4033 18.1092 74.6267 18.3326 74.9022 18.3326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1508 20.8101V13.121H73.2988",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5057 13.1211H79.6538",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4561 17.0606V19.7307C90.1477 19.7307 90.811 19.4559 91.3001 18.9669C91.7892 18.4778 92.064 17.8145 92.064 17.1228C92.064 17.0428 92.0604 16.9636 92.0533 16.8854C91.9072 15.266 89.4561 15.4346 89.4561 17.0606Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4561 19.7307C90.1477 19.7307 90.811 19.456 91.3001 18.9669C91.7892 18.4778 92.064 17.8145 92.064 17.1228",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2568 21.7083C79.4172 21.8686 79.6076 21.9958 79.8171 22.0826C80.0266 22.1694 80.2511 22.214 80.4779 22.214C80.7047 22.214 80.9292 22.1694 81.1388 22.0826C81.3483 21.9958 81.5386 21.8686 81.699 21.7083",
    stroke: "#FF6498",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1509 20.816L78.8356 21.2301",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.412 59.7439V100.491L58.688 114.679V69.2974C58.688 61.4781 61.3097 53.8846 66.134 47.731C70.9583 41.5774 77.7066 37.2191 85.2998 35.3528H85.2999C88.9984 34.4437 92.8551 34.3877 96.5785 35.1889C100.302 35.99 103.794 37.6274 106.791 39.9772C109.789 42.327 112.212 45.3276 113.879 48.7521C115.546 52.1766 116.412 55.9353 116.412 59.7439V59.7439Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8673 279.736L89.8223 272.487L107.809 99.6274",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9027 29.6419C74.9027 29.6419 42.9168 28.7039 61.0919 11.3496C79.267 -6.0047 85.4817 2.2034 85.4817 2.2034C85.4817 2.2034 97.0903 7.72424 97.0903 17.3346C97.0903 26.945 90.76 29.6419 90.76 29.6419",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0249 17.7416C72.0249 17.7416 81.2318 14.6328 82.0668 9.3562C82.0668 9.3562 83.346 15.9227 89.4559 16.3917",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.278 38.8804C105.278 38.8804 144.932 67.5165 141.062 84.4018C137.193 101.287 79.8019 99.8799 74.9027 92.4926C70.0036 85.1053 71.6299 86.8642 71.6299 86.8642C71.6299 86.8642 59.0282 86.747 61.8424 83.581C64.6566 80.415 111.161 72.4414 111.161 72.4414L107.809 68.3033",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8355 37.6318C78.8355 37.6318 53.2228 48.0632 50.4086 79.0195C50.4086 79.0195 38.9706 38.4396 24.6244 34.6147C12.4419 31.3667 13.6151 33.2844 11.4328 32.7702C8.17217 32.0018 19.1719 38.8803 19.1719 38.8803C19.1719 38.8803 15.4782 48.5205 24.3517 50.0416C24.3517 50.0416 10.7882 108.086 58.6882 114.679",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople4);
export default __webpack_public_path__ + "static/media/people-4.d432d0a9e6e017c5ef7b7b372f613e21.svg";
export { ForwardRef as ReactComponent };